import { render, staticRenderFns } from "./FaultTypeSelect.vue?vue&type=template&id=120d36d6"
import script from "./FaultTypeSelect.vue?vue&type=script&lang=ts"
export * from "./FaultTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports